<template>
  <div class='tops_body sectionbox' @finished-proc="onFinishedProc">
    <div v-if="show_plan_list == true" class="sp_not pc-calendar mb-3 mt-0">
        <div class="head-sticky">
            <div>
                <div id='tabArea'>
                    <span v-for="month in dispMonth" :key="month.key">
                        <label class="month_botton" :class='month.class'>
                            <input type="radio" name='radio_month' @click="onSelectMonth(month.key)">{{ month.dispName }}
                        </label>
                    </span>
                </div>
            </div>
            <div class="text-right">※数字はプレー料金を表示しています。(100円単位)</div>
        </div>
        <table class="calendar-table">
            <thead class="thead-sticky">
                <tr>
                    <th rowspan="4">
                        <div class="d-flex align-items-center w-100">
                            <div class="text-right plan-head">
                                <span>プラン名</span>
                            </div>
                            <div class="text-right icon-head">
                                <span class="icon-explanation iconsExplanation bluebackbutton p-1 mr-0" v-on:click='onOpenIconDialog'>アイコンの説明</span>
                            </div>
                        </div>
                    </th>
                    <th class="table_price_header text-center" rowspan="4">料金</th>
                </tr>
                <tr>
                    <th v-for="calHeadMonth in calHeadMonthList"
                        :key="calHeadMonth.month"
                        :colspan="calHeadMonth.length"
                        class="text-center th-sticky">
                        {{ calHeadMonth.month }}月
                    </th>
                </tr>
                <tr>
                    <th class='th-sticky' :class="calHeadDay.class" v-for="calHeadDay in calHeadDayList" :key="calHeadDay.key">
                        {{ calHeadDay.date }}
                    </th>
                </tr>
                <tr>
                    <th class='th-sticky' :class="calHeadDay.class" v-for="calHeadDay in calHeadDayList" :key="calHeadDay.key">
                        {{ calHeadDay.dayOfWeek }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="calPlan in calPlanList" :key="calPlan.planId">
                    <td>
                        <div class='ml-2'>
                            <span class="plan-name font-weight-bold" v-on:click='onOpenPlanDialog(calPlan.planId)'>{{ calPlan.planName }}</span>
                        </div>
                        <div class="ml-2 icons">
                            <span v-for="icon in calPlan.iconFlag" :key="icon.id">
                                <div class="play-style-icon" :class="icon.class"></div>
                            </span>
                        </div>
                    </td>
                    <td class="text-center font-weight-bold">
                        {{ calPlan.planFeeMin }}<br>
                        {{ calPlan.totalStr }}<br>
                        {{ calPlan.planFeeMax }}
                    </td>
                    <td :class="day.class" v-for="day in calPlan.days" :key="day.key">
                        <div v-if="dispCalendarNum === 1">
                            <button
                                class="w-75"
                                :class="day.btnClass"
                                @click="onSelect(calPlan.planId, day.key, day.dispImg, day.reserveType, day.reserveApproval)"
                                :disabled="day.disabled"
                                >
                                {{ day.dispImg }}</button><br>
                        </div>
                        <div v-else class="imgposition">
                            <div
                                :class="day.dispClass"
                                @click="onSelect(calPlan.planId, day.key, day.dispImg, day.reserveType, day.reserveApproval)"
                            >{{ day.dispImg }}</div><br>
                        </div>
                        <span style='font-size: 0.70rem;' :class="day.feeClass">{{ day.fee }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div>
        <div class="sp-calendar mb-3">
            <div v-for="calHeadDay in calHeadDayList" :key="calHeadDay.spKey" class="container">
                <div class="row datePickWrap py-2">
                    <button
                        class="framebutton frameBtn"
                        :class="{ 'noBeforeDay': beforeToday }"
                        @click="changeDate(-1)"
                    >
                        前日
                    </button>
                    <div class="iconWrap">
                        <Datepicker
                            input-class="calendarBtn pl-2"
                            v-model="reserveData.searchStartDate"
                            :language="ja"
                            :format="DatePickerFormat"
                            :disabled-dates="disabledDates"
                            calendar-button
                            calendar-button-icon="icon-datepick m-0"
                            @closed="setDateBtn()"
                            class="m-0"
                        ></Datepicker>
                    </div>
                    <button
                        class="framebutton frameBtn"
                        @click="changeDate(1)">
                        翌日
                    </button>
                </div>
            </div>
            <div v-for="calPlan in calPlanList" :key="calPlan.planId">
                <div
                    class="container"
                    style="background-color: white;"
                    >
                    <div class="row py-2 sp-cal-plan-name">
                        <div class='col text-center'>
                            <a v-on:click='onOpenPlanDialog(calPlan.planId)'>{{ calPlan.planName }}</a>
                        </div>
                    </div>
                    <div class="row justify-content-center py-3">
                        <div class='col-11 align-self-center sp-cal-icon-record'>
                            <h5 class="font-weight-bold">プレースタイル
                                <span class="icon-explanation bluebackbutton float-right p-1 h-auto" v-on:click='onOpenIconDialog'>アイコンの説明</span>
                            </h5>
                            <span v-for="icon in calPlan.iconFlag" :key="icon.id">
                                <div class="play-style-icon" :class="icon.class"></div>
                            </span>
                        </div>
                    </div>
                    <div class="row justify-content-center py-2">
                        <div class='col-12'>
                            <p>
                                <span class="font-weight-bold">料金:</span>
                                <span class="font-weight-bold">{{ calPlan.planFeeMin }}{{ calPlan.totalStr }}{{ calPlan.planFeeMax }}</span>
                            </p>
                        </div>
                    </div>
                    <div
                        v-for="day in calPlan.days"
                        :key="day.key"
                        class="row pb-4 justify-content-center">
                        <button
                            @click="onSelect(calPlan.planId, day.key, day.dispImg, day.reserveType, day.reserveApproval)"
                            class="col-11"
                            :class="day.btnClass"
                            :disabled="day.disabled"
                            >
                            {{ day.dispImg }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="show_plan_list == true">
          <div v-if="calPlanList.length === 0"><p class="plan_notfound bg-single">該当するプランがありません。</p></div>
        </div>
    </div>
    <div>
      <ExplanationPlanDialogModal
        ref="ExplanationPlan"
        v-show="showPlanDialog"
        v-on:closePlanDialog="onClosePlanDialog">
      </ExplanationPlanDialogModal>
      <ExplanationIconDialogModal
        ref="ExplanationIcon"
        v-show="showIconDialog"
        v-on:closeIconDialog="onCloseIconDialog">
      </ExplanationIconDialogModal>
      <ErrorWordingDialogModal
        v-show="showError"
        v-bind:errorWording="errorMessage"
        v-on:closeErrorDialog="CloseErrorDialog"
      ></ErrorWordingDialogModal>
    </div>
  </div>
</template>

<script>
import ReserveHeader from './ReserveHeader';                                   // 予約画面ヘッダ
import ConditionSearch from './ConditionSearch';                               // プラン条件検索
import ExplanationPlanDialogModal from './dialog/ExplanationPlanDialog';       // プラン詳細ダイアログ
import ExplanationIconDialogModal from './dialog/ExplanationIconDialog';       // アイコン説明ダイアログ
import ErrorWordingDialogModal from '../components/ErrorDialog';
import { GET_PLAN_CELL_LIST } from '../../constants/plan_master';
import { CODE_MASTER } from '../../config';
import { utilityMixin } from '../../mixins/utility';
import { ja } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        ReserveHeader,
        ConditionSearch,
        ExplanationPlanDialogModal,
        ExplanationIconDialogModal,
        ErrorWordingDialogModal,
        Datepicker
    },
    mixins: [utilityMixin],
    data () {
        return {
            loginState: false,
            golfCode: null,
            reserveData: {
                // ゴルフコード
                golfCode: null,
                // 会員番号
                memberNo: null,
                // 会員種別（ポイント会員、Web会員）
                memberRank: null,
                // 開始日
                searchStartDate: null,
                // 何日分
                searchSelectDays: 31,
                // 枠数
                searchSelectCells: 1,
                // 下限料金
                searchPriceMin: 1,
                // 上限料金
                searchPriceMax: 1,
                // スタート時間
                searchStartTimeList: [],
                // スタイル
                searchStyleList: [],
                // 特典
                searchBenefitsList: [],
                // プランID
                calendarPlanId: null,
                // 選択日
                calendarSelectDate: null,
                // 選択予約種別
                calendarReserveType: null,
                // 予約番号（変更時）
                myPageReserveNo: null,
            },
            showPlanDialog: false,
            showIconDialog: false,
            normal_reserve_select: null,
            share_reserve_select: null,
            member_no: '',
            calPlanList: [],
            soldOutList: [],
            dispMonth: [],
            selectPlanId: null,
            month: null,
            calHeadDayList: [],
            calHeadMonthList: [],
            show_plan_list: false,
            startDate:  null,
            dateNum: 0,
            // カレンダー表示月数
            showMaxMonth: 12,
            // カレンダーボタン表示用
            dispCalendarNum: null,
            // エラーダイアログ表示フラグ
            showError: false,
            // エラーダイアログの文言
            errorMessage: null,
            // 子コンポーネント数（ダイアログを除く）
            childComponentNum: 2,
            routeData: '',
            routeName: '',
            isMobile: false,
            // vuejs-datetimepickerの設定
            ja: ja,
            DatePickerFormat: 'yyyy年MM月dd日',
            disabledDates: {
                to: new Date()
            },
            selectDate: null,
            beforeToday: true,
            allSettingDays: []
        };
    },
    created () {
        this.initialize();
    },
    watch: {
        'reserveData.searchStartDate' () {
            this.onSearcBtn();
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
            this.$store.commit("loading/setIsLoading", true);

            // ゴルフ場サイトから遷移した場合
            if (this.$route.query.gc) {
                this.golfCode = this.$route.query.gc;
                this.reserveData.golfCode = this.$route.query.gc;
                this.reserveData.memberRank = this.$route.query.ud;
                var dt = new Date();
                this.reserveData.searchStartDate = dt.setDate(dt.getDate() + 1);
                this.isMobile = this.checkMobile();
                if(this.isMobile){
                    this.reserveData.searchSelectDays = 1;
                }
            }
            this.onSearcBtn();
        },
        /** ----------------------------------------------
         * 処理終了処理
         * 　カレンダー画面の初期処理が完了した時点で呼ばれる
         * @param {Boolean} status true:正常  false:異常
         * ---------------------------------------------- */
        onFinishedProc: function (status) {
            if (status) {
                this.$store.commit("loading/setIsLoading", false);
            } else {
                this.$store.commit("loading/setIsLoading", false);
            }
        },
     /** ----------------------------------------------
         * 検索画面の検索ボタン押下
         * 　条件に応じたプランを取得し、表示する。
         * ---------------------------------------------- */
        onSearcBtn () {
            this.$store.commit("loading/setIsLoading", true);

            // 検索条件取得
            this.startDate = new Date(this.reserveData.searchStartDate);
            this.dateNum = this.reserveData.searchSelectDays;
            this.dispCalendarNum = Number(this.dateNum);

            // 月タブ設定
            var tabMonth = new Date(this.startDate.getTime());
            var targetYear = tabMonth.getFullYear();
            var targetMonth = tabMonth.getMonth() + 1;
            this.dispMonth = [];
            var tempMonth = {};
            tempMonth['key'] = 0;
            tempMonth['class'] = 'bluebackbutton';
            tempMonth['dispName'] = '直近';
            tempMonth['countYear'] = targetYear;
            tempMonth['countMonth'] = targetMonth;
            this.dispMonth.push(tempMonth);
            if (targetMonth === 12) {
                targetMonth = 0;
                targetYear = targetYear + 1;
            }
            for (var i = 1; i < this.showMaxMonth; i++) {
                var tempMonth = {};
                var countMonth = targetMonth + i;
                tempMonth['key'] = i;
                tempMonth['class'] = 'framebutton';
                tempMonth['dispName'] = countMonth + '月';
                tempMonth['countYear'] = targetYear;
                tempMonth['countMonth'] = countMonth;
                if (countMonth === 12) {
                    targetMonth = 0 - i;
                    targetYear = targetYear + 1;
                }
                this.dispMonth.push(tempMonth);
            }
            // プラン検索
            this.getPlan (this.startDate, this.dateNum);
            this.show_plan_list = true;
        },
        /** ----------------------------------------------
         * プラン詳細画面表示
         * ---------------------------------------------- */
        onOpenPlanDialog (planId) {
            this.$refs.ExplanationPlan.open(this.reserveData.golfCode, planId);
            this.showPlanDialog = true;
        },
        /** ----------------------------------------------
         * プラン詳細画面閉じる
         * ---------------------------------------------- */
        onClosePlanDialog () {
            this.showPlanDialog = false;
        },
        /** ----------------------------------------------
         * アイコン説明画面表示
         * ---------------------------------------------- */
        onOpenIconDialog () {
            this.$refs.ExplanationIcon.open();
            this.showIconDialog = true;
        },
        /** ----------------------------------------------
         * アイコン説明画面閉じる
         * ---------------------------------------------- */
        onCloseIconDialog () {
            this.showIconDialog = false;
        },
        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        CloseErrorDialog () {
            this.showError = false;
        },

        /** ----------------------------------------------
         * 月タブ選択
         * ---------------------------------------------- */
        onSelectMonth (idx) {
            var targetDate = null;
            var targetNum = null;
            if (idx == 0) {
                this.dispMonth[0]['class'] = 'bluebackbutton';
                for (var i = 1; i < this.showMaxMonth; i++) {
                    this.dispMonth[i]['class'] = 'framebutton';
                }
                targetDate = this.startDate;
                targetNum = this.dateNum;
                this.dispCalendarNum = Number(targetNum);
            } else {
                this.dispMonth[0]['class'] = 'framebutton';
                for (var i = 1; i < this.showMaxMonth; i++) {
                    if (i == idx) {
                        this.dispMonth[i]['class'] = 'bluebackbutton';
                    } else {
                       this.dispMonth[i]['class'] = 'framebutton';
                    }
                }
                // 選択月を取得
                // targetDate = new Date(this.startDate.getTime());
                // targetDate.setMonth(targetDate.getMonth() + idx);
                // targetDate.setDate(1);
                targetDate = new Date(this.dispMonth[idx]['countYear'], this.dispMonth[idx]['countMonth'] - 1, 1);
                // 月末日を取得
                var workMonth = new Date(targetDate.getFullYear(), targetDate.getMonth() + 1, 0);
                targetNum = workMonth.getDate();
                this.dispCalendarNum = Number(targetNum);
            }
            // プラン検索
            this.getPlan (targetDate, targetNum);
        },
        /** ----------------------------------------------
         * プランカレンダー表示処理
         * @param {Array} planCellList
         * @param {String} startDate 選択日
         * @param {String} dateNum 検索日数
         * ---------------------------------------------- */
        showPlan: async function (planCellList, soldOutCellList, startDate, dateNum) {
            var headMonth = new Date(startDate.getTime());
            this.month = headMonth.getMonth() + 1;

            // 満席のチェック
            this.soldOutList = soldOutCellList;

            var tempPlanId = '';
            this.calPlanList = [];
            for (var i = 0 ; i < planCellList.length ; i++) {
                if (tempPlanId != planCellList[i]['plan_id']) {
                    tempPlanId = planCellList[i]['plan_id'];
                    var planItem = {};
                    planItem['planId'] = tempPlanId;
                    planItem['planName'] = planCellList[i].plan_name;

                    // プレースタイル
                    planItem['iconFlag'] = [];
                    if (planCellList[i].meal_flag !== CODE_MASTER.NOT_USE_SETTING) {
                        planItem['iconFlag'].push({ id: 1, class: planCellList[i].meal_flag_icon });
                    }
                    planItem['iconFlag'].push({ id: 2, class: planCellList[i].cart_code_icon });
                    planItem['iconFlag'].push({ id: 3, class: planCellList[i].guarantee_code_icon });
                    if (planCellList[i].caddie_flag !== CODE_MASTER.NOT_USE_SETTING) {
                        planItem['iconFlag'].push({ id: 4, class: planCellList[i].caddie_flag_icon });
                    }
                    planItem['iconFlag'].push({ id: 5, class: planCellList[i].round_code_icon });
                    if (planCellList[i].accommodation_flag !== CODE_MASTER.NOT_USE_SETTING) {
                        planItem['iconFlag'].push({ id: 6, class: planCellList[i].accommodation_flag_icon });
                    }
                    planItem['iconFlag'].push({ id: 7, class: planCellList[i].share_flag_icon });

                    planItem['planFeeMin'] = planCellList[i].plan_fee_min.toLocaleString() + "円";
                    // 最小金額と最大金額が同じ場合
                    if (planCellList[i].plan_fee_min == planCellList[i].plan_fee_max) {
                        planItem['totalStr'] = "(総額)";
                    } else {
                       planItem['totalStr'] = "~";
                       planItem['planFeeMax'] = planCellList[i].plan_fee_max.toLocaleString() + "円";
                    }

                    var tempDate = new Date(startDate.getTime());
                    var calList = [];
                    for (var dayCnt = 0 ; dayCnt < dateNum ; dayCnt++) {
                        var tempDateStr = this.getDateStr(tempDate);
                        // let planRec = planCellList.find((rec) => (rec.play_date === tempDateStr && rec.player_left >= 1 && rec.plan_id === tempPlanId && (rec.reserve_status != 0 && rec.reserve_status != 3 && rec.reserve_status != 9)));
                        // share_flagが「0(保証なし)」の時はreserve_statusは「1」となっている。share_flagが「1(保証あり)」の時はreserve_statusは「2」となっている。reserve_status＝share_flag＋1で判断する。
                        // let planRec = planCellList.find((rec) => (rec.play_date === tempDateStr && rec.player_left >= 1 && rec.plan_id === tempPlanId && (rec.reserve_status === (rec.share_flag + 1) || rec.reserve_status === 1 )));

                        // 残席数が「0」となっているデータ(soldOutList)内に該当のプランがなければ予約不可とする。soldOutListには枠のあるデータのみがある。
                        let planNoRec = this.soldOutList.find((rec) => rec.play_date == tempDateStr && rec.player_left <= 0 && rec.plan_id == tempPlanId);
                        /**
                         * プランに一致する枠があるかどうか確認
                         */
                        let planRec = planCellList.find( (rec) => (
                            rec.play_date === tempDateStr // 取得したデータと表示しようとしている日付が同じ
                            && rec.player_left >= 1       // 残席数が1以上
                            && rec.plan_id === tempPlanId // 取得したデータと表示しようとしているプランが同じ
                            && !planNoRec                 // 残席数チェック
                            && (
                                ( rec.reserve_status === 2)                          // reserve_statusが2:シェア枠  もしくは
                             || ( rec.share_flag === 0 && rec.reserve_status === 1 ) // 0:保証ありの場合、1:予約可 も表示
                            )
                        ));

                        var calInf = {};
                        calInf['key'] = tempDateStr;
                        let judgeDay = this.judgeDay(tempDate, this.allSettingDays);
                        // カレンダーのアイコン部分の背景色を土曜日の場合は青色、日曜日の場合は赤色にする。
                        if (judgeDay == CODE_MASTER.DAY_HOLIDAY) {
                            calInf['class'] = "td_holidaybackground";
                        } else if(judgeDay == CODE_MASTER.DAY_SATURDAY) {
                            calInf['class'] = "td_saturdaybackground";
                        } else {
                            calInf['class'] = "td_background";
                        }

                        // カレンダーに表示するイメージを設定する
                        if (planRec) {
                            var checkClose = this.checkClosingDate(planRec.play_date, planRec.closing_days, planRec.closing_time);
                            if (checkClose) {
                                // リクエスト不可の場合
                                if (planRec.request_flag == 0) {
                                    // シェア不可の場合
                                    if (planRec.share_flag == 0) {
                                        calInf['dispImg'] = (dateNum == 1) ? "予約" : "";
                                        calInf['reserveType'] = CODE_MASTER.RESERVE_TYPE_NORMAL;
                                        calInf['reserveApproval'] = planRec.request_approval;
                                        calInf['dispClass'] = 'disp_img_circle_fill';
                                    } else {
                                        calInf['dispImg'] = (dateNum == 1) ? "予約" : "";
                                        calInf['reserveType'] = CODE_MASTER.RESERVE_TYPE_SHARE;
                                        calInf['reserveApproval'] = planRec.request_approval;
                                        calInf['dispClass'] = 'disp_img_circle';
                                    }
                                } else {
                                    calInf['dispImg'] = (dateNum == 1) ? "予約" : "";
                                    calInf['reserveType'] = CODE_MASTER.RESERVE_TYPE_REQUEST;
                                    calInf['dispClass'] = 'disp_img_square';
                                }
                                calInf['fee_original'] = planRec.total_fee;
                                calInf['fee'] = Math.floor(planRec.total_fee / 100);
                                calInf['btnClass'] = 'can-reserve-button';
                                calInf['disabled'] = false;
                                calInf['reserveApproval'] = planRec.request_approval;
                            } else {
                                calInf['dispImg'] = (dateNum == 1) ? "予約不可" : "";
                                calInf['reserveType'] = "00";
                                calInf['dispClass'] = 'disp_img_hyphen';
                                calInf['btnClass'] = 'btn btn-secondary cant-reserve-button';
                                calInf['feeClass'] = 'none_fee';
                                calInf['disabled'] = true;
                                calInf['feeClass'] = 'none_fee';
                                calInf['fee_original'] = 0;
                            }
                        } else {
                            if (planNoRec) {
                                if (planNoRec.request_flag == 0 && planNoRec.request_approval == 0) {
                                    calInf['dispImg'] = (dateNum == 1) ? "予約不可" : "";
                                    calInf['reserveType'] = "00";
                                    calInf['dispClass'] = 'disp_img_hyphen';
                                    calInf['btnClass'] = 'btn btn-secondary cant-reserve-button';
                                    calInf['disabled'] = true;
                                    calInf['reserveApproval'] = planNoRec.request_approval;
                                } else if (planNoRec.request_flag == 0 && planNoRec.request_approval == 1) {
                                    calInf['dispImg'] = (dateNum == 1) ? "予約" : "";
                                    calInf['reserveType'] = CODE_MASTER.RESERVE_TYPE_REQUEST;
                                    calInf['reserveApproval'] = planNoRec.request_approval;
                                    calInf['dispClass'] = 'disp_img_square';
                                    calInf['btnClass'] = 'can-reserve-button';
                                    calInf['disabled'] = false;
                                    calInf['reserveApproval'] = planNoRec.request_approval;
                                } else {
                                    calInf['dispImg'] = (dateNum == 1) ? "予約" : "";
                                    calInf['reserveType'] = CODE_MASTER.RESERVE_TYPE_REQUEST;
                                    calInf['dispClass'] = 'disp_img_square';
                                    calInf['btnClass'] = 'can-reserve-button';
                                    calInf['disabled'] = false;
                                    calInf['reserveApproval'] = planNoRec.request_approval;
                                }
                                calInf['fee_original'] = planNoRec.total_fee;
                                calInf['fee'] = Math.floor(planNoRec.total_fee / 100);
                            } else {
                                calInf['dispImg'] = (dateNum == 1) ? "予約不可" : "";
                                calInf['reserveType'] = "00";
                                calInf['dispClass'] = 'disp_img_hyphen';
                                calInf['btnClass'] = 'btn btn-secondary cant-reserve-button';
                                calInf['feeClass'] = 'none_fee';
                                calInf['disabled'] = true;
                                calInf['feeClass'] = 'none_fee';
                                calInf['fee_original'] = 0;
                            }
                        }
                        calList.push(calInf);
                        tempDate.setDate(tempDate.getDate() + 1);
                    }
                    planItem['days'] = calList;
                    planItem['fee_original'] = calInf['fee_original']; // 1日で検索した場合に表示する当日の金額
                    this.calPlanList.push(planItem);
                }
            }
        },
                /** ----------------------------------------------
         * 予約日選択押下
         * @param {String} planId プランID
         * @param {String} day 選択日
         * @param {String} reserveType 予約種別
         * ---------------------------------------------- */
        onSelect (planId, day, dispImg, reserveType, requestApproval) {
            this.reserveData.calendarPlanId = planId;
            this.reserveData.calendarSelectDate = day;
            this.reserveData.requestApproval = requestApproval;
            sessionStorage.setItem('Reserve.clickPage','/reserve');

            if (reserveType == CODE_MASTER.RESERVE_TYPE_NORMAL) {
                this.reserveData.calendarReserveType = CODE_MASTER.RESERVE_TYPE_NORMAL;
                sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
                this.routeName = "StartTimeSelect";
            } else if (reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                this.reserveData.calendarReserveType = CODE_MASTER.RESERVE_TYPE_SHARE;
                sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
                this.routeName = "StartTimeSelect";
            } else if (reserveType == "00") {
                sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
                return;
            } else {
                this.reserveData.calendarReserveType = CODE_MASTER.RESERVE_TYPE_REQUEST;
                this.routeName = "RequestTimeSelect";
            }
            sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            this.routeData = this.$router.resolve({name: this.routeName});
            window.open(this.routeData.href, '_blank');
        },
        /** ----------------------------------------------
         * 検索画面の検索ボタン押下
         * 　条件に応じたプランを取得し、表示する。
         * ---------------------------------------------- */
        getPlan (startDate, dateNum) {

            var priceMin = this.reserveData.searchPriceMin;
            var priceMax = this.reserveData.searchPriceMax;
            var startTimeList = this.reserveData.searchStartTimeList;
            var styleList = this.reserveData.searchStyleList;
            var benefitsList = this.reserveData.searchBenefitsList;

            var endDate = new Date(startDate.getTime());
            endDate.setDate(endDate.getDate() + parseInt(dateNum) - 1);
            var startDateStr = this.getDateStr(startDate);
            var endDateStr = this.getDateStr(endDate);

            // プラン検索
            this.$apollo.query({
                query: GET_PLAN_CELL_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.reserveData.golfCode,
                    member_no: this.reserveData.memberNo,
                    play_date_from: startDateStr,
                    play_date_to: endDateStr,
                    cell_number: this.reserveData.searchSelectCells,
                    price_min_code: priceMin,
                    price_max_code: priceMax,
                    start_times_codes: startTimeList,
                    style_codes: styleList,
                    benefit_codes: benefitsList
                }
            }).then(res => {
                this.allSettingDays = res.data.getPlanCellList.AllSettingDays;
                this.setDate(startDate, dateNum);
                this.setMonthDate(startDate, dateNum);
                this.showPlan(res.data.getPlanCellList.PlanCellList, res.data.getPlanCellList.SoldOutCellList, startDate, dateNum);
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                const message = error.message.split(':');
                this.$store.commit("loading/setIsLoading", false);
            });

        },
        /** ----------------------------------------------
         * カレンダー日付設定処理
         * @param startDate 開始日
         * @param dateNum 日数
         * ---------------------------------------------- */
        setDate: function (startDate, dateNum) {
            var tempDate = new Date(startDate.getTime());
            this.calHeadDayList = [];
            for (var i = 0; i < dateNum; i++) {
                var dateItem = {};
                dateItem['key'] = i + 1;
                dateItem['spKey'] = `sp_${i + 1}`;
                dateItem['date'] = tempDate.getDate();
                dateItem['dayOfWeek'] = this.getDayJapanese(tempDate);
                let judgeDay = this.judgeDay(tempDate, this.allSettingDays);
                // カレンダーの日付、曜日部分の背景色を土曜日の場合は青色、日曜日の場合は赤色にする。
                if(judgeDay == CODE_MASTER.DAY_HOLIDAY) {
                    dateItem['class'] = "day_header_holiday";
                } else if(judgeDay == CODE_MASTER.DAY_SATURDAY) {
                    dateItem['class'] = "day_header_saturday";
                } else {
                    dateItem['class'] = "text-center";
                }
                this.calHeadDayList.push(dateItem);

                // １日加算
                tempDate.setDate(tempDate.getDate() + 1);
            }
        },
        /** ----------------------------------------------
         * カレンダー日付設定処理
         * @param startDate 開始日
         * @param dateNum 日数
         * @return [{month: 該当の月, 今日から末日までの日数: diff }, {翌月, dateNum - diffの日数}]
         * ---------------------------------------------- */
        setMonthDate: function (startDate, dateNum) {
            this.calHeadMonthList = [];

            const thisMonth = startDate.getMonth() + 1;
            const thisDay = startDate.getDate();

            // 末日を取得
            const tmp = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
            const thisLastDay = tmp.getDate();

            const diff = thisLastDay - thisDay;
            const nextdiff = Number(dateNum) - diff;
            this.calHeadMonthList.push({
                month: thisMonth,
                length: diff + 1
            });
            if (thisDay !== 1) {
                if (nextdiff > 1) {
                    var nextMonth = startDate.getMonth() + 2;
                    if (nextMonth === 13) {
                        nextMonth = 1;
                    }
                    this.calHeadMonthList.push({
                        month: nextMonth,
                        length: nextdiff
                    });
                }
            }
        },
        changeDate: function (days) {
            var tommorow = new Date();
            tommorow.setDate(tommorow.getDate() + 1);
            var dt = new Date(this.reserveData.searchStartDate);
            this.reserveData.searchStartDate = dt.setDate(dt.getDate() + days);

            if (this.reserveData.searchStartDate <= tommorow) {
                this.beforeToday = true;
            } else {
                this.beforeToday = false;
            }
        },
        setDateBtn: function () {
            var tommorow = new Date();
            tommorow.setDate(tommorow.getDate() + 1);
            var dt = new Date(this.reserveData.searchStartDate);

            this.reserveData.searchStartDate = Date.parse(dt);

            var target1 = dt.toLocaleDateString( "ja-JP" );
            var target2 = tommorow.toLocaleDateString( "ja-JP" );

            if (Date.parse(target1) <= Date.parse(target2)) {
                this.beforeToday = true;
            } else {
                this.beforeToday = false;
            }
        }
    }
}

</script>

<style scoped>
#tabArea {
    display: flex;
    justify-content: flex-start;
    column-gap: 10px;
    align-items: center;
}
#tabArea input[type="radio"] {
    display: none;                /* ラジオボタン非表示 */
}
th{
  border: solid 1px #f3f3f3;
}
tr{
  border: solid 1px #f3f3f3;
}
td{
  border: solid 1px #f3f3f3;
}
.disp_img_hyphen{
    width: 15px;
    height: 2px;
    vertical-align: -75%;
    background-color:#858585;
    display: inline-flex;
}
.none_fee{
    display: block;
    height: 25px;
}
.imgposition{
    height: 50px;
}
.table_price_header{
    min-width: 5.5rem;
    max-width: 20%;
}
.td_holidaybackground{
    text-align: center;
    background: #efdecd;
}
.td_saturdaybackground{
    text-align: center;
    background: #c6ebeb;
}
.td_background{
    text-align: center;
    background: white;
}
.day_header_holiday{
    text-align: center;
    background: #efdecd;
    color: red;
}
.day_header_saturday{
    text-align: center;
    background: #c6ebeb;
    color: blue;
}
.plan_notfound {
    text-align:center;
    font-size: 1.5rem;
}
.ballot_box{
    font-size: 1.3rem;
}
.sp_title {
    font-size: 1.3rem;
}
.noBeforeDay {
    visibility: hidden;
}
.datePickWrap {
    justify-content: space-between;
    align-items: center;
}
.calendarWrap {
    position: relative;
}
.calendarWrap input[readonly] {
    background-color: #30BAAF !important;
}
.calendarPosition {
    left: -85px !important;
}
.vdp-datepicker >>> .vdp-datepicker__calendar {
    left: -65px !important;
}
.iconWrap {
    position: relative;
}
.thead-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 87px;
    background-color: #fff;
}
.th-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 87px;
    background-color: #fff;
}
.thead-sticky::before {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px solid #e8e8e8;
}
.th-sticky::before {
    display: block;
    position: absolute;
    top: -1px;
    left: -1px;
    width: 100%;
    height: 100%;
    border-top: 1px solid #e8e8e8;
}
.iconsExplanation {
    position: relative;
}
.plan-name {
    font-size: 0.9rem;
    text-decoration: underline;
    cursor: pointer;
}
.play-style {
    min-width: 250px;
}
.frameBtn {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
.month_botton {
    width: 75px;
    height: 35px;
    text-align: center;
    line-height: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
.calendar-table {
    border-spacing: 0;
    border-collapse: separate;
}
@media screen and (max-width: 896px) {
    .vdp-datepicker{
        display: block;
    }
    .sp-calendar{
        display: block;
        padding: 0 5px;
    }
}
.icons {
    height: 40px;
}
.plan-head {
    width: 60%;
}
.icon-head {
    width: 40%;
}
</style>
